import { Platform, StyleSheet, TextStyle } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const { colorBgPrimaryLight, colorBgBase, colorTextMedium, space2, space20, space8, space6, space4 } = theme();

  return StyleSheet.create({
    buttonsWrapper: {
      alignSelf: "flex-start",
      marginTop: space2,
    },
    content: {
      alignSelf: "center",
      paddingHorizontal: space6,
    },
    contentLarge: {
      flex: 1,
      marginBottom: space20,
    },
    contentSmall: {
      paddingVertical: space6,
    },
    contentWrapper: {
      backgroundColor: colorBgBase,
      flex: 1,
      justifyContent: "center",
    },
    goToOrderButton: {
      marginBottom: space4,
    },
    text: {
      color: colorTextMedium,
      marginBottom: space6,
    },
    textBold: {
      color: colorTextMedium,
      fontFamily: "AreaNormal-Extrabold",
      ...Platform.select({
        web: {
          display: "inline",
        } as unknown as TextStyle,
      }),
    },
    title: {
      marginBottom: space4,
    },
    wrapper: {
      backgroundColor: colorBgPrimaryLight,
      flex: 1,
      paddingBottom: space8,
    },
  });
};

export { style };
